import locale from "csi/locale";
import Delete from "csi/table/Delete";
import MessageDialog from "csi/widget/MessageDialog";
import declare from "dojo/_base/declare";

const DeleteSizeChart = declare(Delete, {

	/**
     * @override
     */
	confirmAction(params: any): void {
		const sizeChart = this.getContext().getNode();
		if (sizeChart.StyleSizeCharts.length) {
			params.materialIcon = MessageDialog.ICON_WARNING;
			params.title = locale.resource("DeleteLinkedSizeChart_Title");
			params.message = locale.resource("DeleteLinkedSizeChart_Confirm");
			this.m_action.confirmAction = MessageDialog.BUTTON_UNLINK_AND_DELETE;
		} else {
			this.m_action.confirmAction = MessageDialog.BUTTON_DELETE;
		}

		this.inherited(arguments);
	},
});

export = DeleteSizeChart;
